export default "__VITE_ASSET__CDNqsZ_t__"